import { defineMessages, MessageDescriptor } from '@formatjs/intl';
import { SignatureStatus } from 'gql/index';

export const ElectronicSignatureStatusMessages: Record<SignatureStatus, MessageDescriptor> = defineMessages({
  [SignatureStatus.Pending]: { id: 'Pending' },
  [SignatureStatus.Denied]: { id: 'Declined' },
  [SignatureStatus.Signed]: { id: 'Signed' },
  [SignatureStatus.Expired]: { id: 'Expired' },
});


export type ChipColors = 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
export const ElectronicSignatureStatusColor: Record<SignatureStatus, ChipColors> = {
  [SignatureStatus.Pending]: 'info',
  [SignatureStatus.Denied]: 'error',
  [SignatureStatus.Signed]: 'success',
  [SignatureStatus.Expired]: 'error',
};